import React, { useEffect, useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import Button from "components/CustomButtons/Button.js";
import swal from "sweetalert2";
import { MantineReactTable } from "mantine-react-table";
import {
  Box,
  ActionIcon,
  Tooltip,


} from "@mantine/core";
import { IconDownload, IconEye } from "@tabler/icons-react";
import { ExportToCsv } from "export-to-csv";
import { IconTrash, IconEdit } from "@tabler/icons-react";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import Pagination from "rc-pagination";
import { CircularProgress, debounce } from "@material-ui/core";
import { toast } from "react-toastify";
const useStyles = makeStyles(styles);

export default function AdminManagement() {
  const location = useLocation();
  const shouldRefetch = location.state?.shouldRefetch;
  console.log(shouldRefetch, "location")
  const classes = useStyles();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("");
  const [showUserList, setShowUserList] = useState(true);
  const [tableData, setTableData] = useState([]);
  console.log(tableData, "tableData")
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(10);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const isEditing = location.pathname.includes("editUser");
  const isViewing = location.pathname.includes("editAdmin");
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [loadingDownload, setLoadingDownload] = useState(false);
  const columns = useMemo(() => [
    {
      header: "User Id",
      accessorKey: "_id",
      size: 10,
    },
    {
      header: "Full Name",
      accessorKey: "fullName",
      size: 10,
    },
    {
      header: "Admin Role",
      accessorKey: "roleName",
      size: 10,
    },

    {
      header: "Email Address",
      accessorKey: "emailAddress",
      size: 10,
    },



    {
      header: "Created Date",
      accessorFn: (row) =>
        row.createdDate !== undefined
          ? new Date(row?.createdDate).toISOString().split("T")[0]
          : "",
      size: 10,
    },

  ]);

  useEffect(() => {
    if (shouldRefetch) {
      getData(pageNumber, limit, search, debouncedSearchText);
      window.history.replaceState({}, document.title);
    } else {
      getData(pageNumber, limit, search, debouncedSearchText);
    }
  }, [pageNumber, limit, search, shouldRefetch, debouncedSearchText]);

  const getData = async (pageNumber, limit, search) => {
    const token = localStorage.getItem("token");

    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/adminUserlist`,
        {
          params: {
            pageNumber,
            limit,
            search: debouncedSearchText,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );


      setTableData(response.data.data);
      setTotalPages(response.data?.pagination?.totalPages || 1);
    } catch (err) {
      console.log(err);

    } finally {
      setLoading(false);
    }
  };


  const handleDelete = async (row) => {
    const token = localStorage.getItem("token");

    const confirmed = await swal.fire({
      title: "Confirm Deletion",
      text: "Are you sure you want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    if (confirmed.isConfirmed) {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/deleteadmin?id=${row.original._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "You have successfully deleted the user.",
        });

        getData();
      } catch (error) {
        console.error(error);
       if (error?.response?.status === 403) {
                await swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "You do not have permission to delete this user.",
                });
              }
      }
    } else if (confirmed.dismiss === swal.DismissReason.cancel) {

      swal.fire({
        icon: "info",
        title: "Cancelled",
        text: "User deletion was cancelled.",
      });
    }
  };



  const handleOpenEditModal = async (rows) => {

    navigate(`editAdmin?userId=${rows.original._id}`);

  };

  useEffect(() => {
    if (location.pathname === "/admin/userManagement") {
      setSelectedOption("");
    }
  }, [location.pathname]);

  const debouncedSearch = useMemo(() => debounce((value) => {
    setDebouncedSearchText(value);
    if (value === "") {
      setPageNumber(1);
      setLimit(10);
    }
  }, 500), []);
  const handleDownload = async () => {
    try {
        setLoadingDownload(true);
      const response = await axios.get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/adminUserlistListDownload`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Admin_List.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if(error.response.status === 403){
               toast.error("You do not have permission to download this file.");
            return;
            }
      console.error('Download error:', error);
    } finally {
      setLoadingDownload(false); 
    }
  }
  return (
    <>
      {!isViewing && !isEditing && showUserList && (
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <Assignment />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Admin Management</h4>

              </CardHeader>

              {!loading ? (
                <CardBody>
                  <MantineReactTable
                    columns={columns}
                    displayColumnDefOptions={{
                      "mrt-row-actions": {
                        mantineTableHeadCellProps: {
                          align: "center",
                        },
                        size: 120,
                      },
                    }}
                    enableFullScreenToggle={false}
                    enableHiding={false}
                    enableDensityToggle={false}
                    enableFilters={false}
                    enableColumnFilterModes
                    enablePagination={false}
                    initialState={{ showColumnFilters: true }}
                    positionToolbarAlertBanner="bottom"
                    data={tableData}
                    enableEditing
                    positionActionsColumn="first"
                    renderTopToolbarCustomActions={({ table }) => (
                      <Box
                        sx={{
                          display: "flex",
                          gap: "16px",
                          padding: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        {loadingDownload ? (
                          <CircularProgress size={24} style={{ color: "black" }} />
                        ) : (
                          <Button
                            onClick={handleDownload}
                            style={{ marginLeft: "auto" }}

                          >
                            Export All Rows
                          </Button>
                        )}
                        <Button
                          disabled={
                            table.getPrePaginationRowModel().rows.length === 0
                          }

                          onClick={() => {
                            navigate("/admin/userManagement")
                          }}
                          leftIcon={<IconDownload />}
                          variant="filled"
                        >
                          End Users
                        </Button>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #ccc",
                            borderRadius: "8px",
                            padding: "6px 12px",
                            width: "300px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <i className="material-icons" style={{ color: "#aaa", marginRight: "8px" }}>
                            search
                          </i>
                          <input
                            type="text"
                            value={searchText}
                            placeholder="Search by Name or ID or Email"
                            onChange={(e) => {
                              setSearchText(e.target.value);
                              debouncedSearch(e.target.value);
                            }}
                            style={{
                              border: "none",
                              outline: "none",
                              width: "100%",
                              fontSize: "14px",
                            }}
                          />

                        </Box>
                      </Box>
                    )}
                    renderRowActions={({ row }) => (
                      <Box sx={{ display: "flex", gap: "16px" }}>

                        <Tooltip withArrow position="left" label="Edit">
                          <ActionIcon onClick={() => handleOpenEditModal(row)}>
                            <IconEdit />
                          </ActionIcon>
                        </Tooltip>
                        <Tooltip withArrow position="right" label="Delete">
                          <ActionIcon
                            color="red"
                            onClick={() => handleDelete(row)}
                          >
                            <IconTrash />
                          </ActionIcon>
                        </Tooltip>
                      </Box>
                    )}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                    }}
                  >
                    <Pagination
                      current={pageNumber}
                      total={totalPages * limit}
                      pageSize={limit}
                      onChange={(page) => setPageNumber(page)}
                    />
                  </Box>
                </CardBody>) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                    width: "100%",
                  }}
                >
                  <CircularProgress size={60} />
                </div>
              )}
            </Card>
          </GridItem>
        </GridContainer>
      )}
      <Outlet />

    </>
  );
}
